import React from "react";
import { Form } from "react-bootstrap";

function FormGroup({ label, type = "text", value, children, ...inputProps }) {
  return (
    <Form.Group>
      <Form.Label>{label}</Form.Label>
      <Form.Control type={type} value={value} {...inputProps} />
      {children && <Form.Text>{children}</Form.Text>}
    </Form.Group>
  );
}

export default FormGroup;
